import { ConnectedProps, connect } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import VisualDemographicTab from "../VisualDemographic/VisualDemographicTabs/TBD";

type PropsFromRedux = ConnectedProps<typeof connector>;
type VisualDemoProps = PropsFromRedux & {};
const VisualDemographicScreen: React.FC<VisualDemoProps> = ({ ...rest }) => {
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        padding: 16,
        flexDirection: "column",
      }}>
      <Tabs>
        <TabList>
          <Tab>Demographic</Tab>
        </TabList>
        <TabPanel>
          <VisualDemographicTab />
        </TabPanel>
      </Tabs>
    </div>
  );
};

const mapState = () => ({});
const connector = connect(mapState, {});

export default connector(VisualDemographicScreen);
